import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPedalBike = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconPedalBike",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M200-160q-85 0-142-57T0-360t59-142 141-58q77 0 130 46t66 114h26l-72-200h-30q-17 0-28-11t-12-29 12-28 28-12h120q17 0 29 12t11 28-11 29-29 11h-4l14 40h192l-58-160h-64q-17 0-28-11t-12-29 12-28 28-12h64q26 0 47 14t29 38l68 186h32q83 0 142 59t58 141q0 84-58 143t-142 59q-72 0-126-45t-70-115H396q-14 69-68 115t-128 45m0-80q41 0 71-22t41-58h-72q-17 0-28-11t-12-29 12-28 28-12h72q-12-36-41-58t-71-22q-51 0-85 35t-35 85q0 50 35 85t85 35m308-160h56q5-23 14-43t22-37H478zm252 160q51 0 86-35t34-85q0-51-34-85t-86-35h-4l26 69q6 16-1 31t-23 20-31-1-21-23l-24-68q-20 17-31 40t-11 52q0 50 35 85t85 35m0-120"
  })
}));
IconPedalBike.displayName = 'IconPedalBike';